import React from "react";
import "./GermanBegins.css";
const GermanBeginsHead = () => {
  return (
    <div className="germanHeadContainer">
      <h2>
        <span>Prizma Academy</span> - Where German Proficiency Begins!
      </h2>
      <p>
        Get ready to dive into the world of German fluency with Prizma Academy,
        the ultimate hub for language learning. Our team of skilled instructors
        and tried-and-true approach guarantee a seamless and fulfilling journey
        towards proficiency. Begin your exciting German language adventure now
        with Prizma Academy!
      </p>
      <div className="germanHeadUnderline"></div>
    </div>
  );
};

export default GermanBeginsHead;
